import { render } from "./OcAttachContent_220321.vue?vue&type=template&id=2870703a&scoped=true"
import script from "./OcAttachContent_220321.vue?vue&type=script&lang=js"
export * from "./OcAttachContent_220321.vue?vue&type=script&lang=js"

import "./OcAttachContent_220321.vue?vue&type=style&index=0&id=2870703a&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2870703a"]])

export default __exports__